<template>
  <!-- 已购素材 -->
  <div style="background-color: #f5f5f5; margin-top: 0.7rem">
    <div class="purchasedMaterial comBox">
      <div class="left">
        <leftTemplate1 :left_tabShow="'purchased_material'"></leftTemplate1>
      </div>
      <div class="right">
        <div style="height: 0.08rem"></div>
        <div style="position: relative">
          <div
            style="
              display: flex;
              right: 0.16rem;
              position: absolute;
              z-index: 1;
            "
          >
            <el-button
              class="topBtn"
              @click="downMulMaterial"
              :disabled="multiple"
              >批量下载素材
            </el-button>
            <!-- <el-button class="topBtn" @click="addInvoice" :disabled="single"
              >申请发票
            </el-button> -->
          </div>
          <el-tabs
            v-model="activeName"
            class="demo-tabs"
            @tab-change="handleClick"
          >
            <el-tab-pane
              :label="item.label"
              :name="item.name"
              v-for="item in activeList"
              :key="item"
            >
              <el-table
                :data="list"
                style="width: 100%"
                height="550"
                @selection-change="handleSelectionChange"
              >
                <el-table-column type="selection" width="55" />
                <el-table-column
                  property="name"
                  min-width="100"
                  label="素材名称"
                >
                  <template #default="scope">
                    <div style="display: flex">
                      <div style="" class="table_img">
                        <el-image
                          style="width: 100%; height: 100%"
                          :src="scope.row.showImage"
                          :zoom-rate="1.2"
                          :preview-src-list="[scope.row.showImage]"
                          :initial-index="4"
                          fit="cover"
                          :preview-teleported="true"
                        >
                          <template #error>
                            <div
                              class="image-slot"
                              style="width: 100%; height: 100%"
                            >
                              <img
                                style="width: 100%; height: 100%"
                                src="../../assets/img/noImg.png"
                              />
                            </div>
                          </template>
                        </el-image>
                      </div>
                      <div class="table_information">
                        <div
                          style="
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            color: #333333;
                          "
                        >
                          {{ scope.row.title }}{{ scope.row.fileExt }}
                        </div>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="授权信息" align="center">
                  <template #default="scope">
                    <span v-if="scope.row.authType == 'SELF'"> 个人授权 </span>
                    <span v-if="scope.row.authType == 'ENTERPRISE'">
                      企业授权
                    </span>
                    <span v-if="scope.row.authType == 'UNION'"> 联盟授权 </span>
                    <span
                      v-if="scope.row.isAuth == 1"
                      class="satatusLab"
                      style="background: #4bc18520; color: #4bc185"
                      >已生效</span
                    >
                    <span
                      v-else
                      class="satatusLab"
                      style="background: #f53f3f20; color: #f53f3f"
                      >未生效</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  label="购买时间"
                  align="center"
                  property="payTime"
                />
                <el-table-column label="操作" width="350" align="center">
                  <template #default="scope">
                    <div style="display: flex; align-items: center">
                      <div style="flex: 2">
                        <div
                          v-if="!scope.row.zipLoading && !scope.row.percentage"
                          style="width: 100px; cursor: pointer"
                          @click="
                            downMaterials(scope.row, [
                              {
                                file: scope.row.title + '.' + scope.row.fileExt,
                                path: scope.row.sourcePath,
                              },
                              { file: '封面.png', path: scope.row.showImage },
                            ])
                          "
                          class="topBtn"
                        >
                          下载素材
                        </div>
                        <el-tag
                          v-else-if="scope.row.zipLoading"
                          :disable-transitions="true"
                          type="warning"
                          >打包中</el-tag
                        >
                        <el-progress
                          v-else-if="scope.row.percentage"
                          :text-inside="true"
                          :stroke-width="15"
                          striped
                          :percentage="scope.row.percentage"
                        ></el-progress>
                      </div>
                      <div
                        @click="addInvoice(scope.row)"
                        style="width: 100px; cursor: pointer"
                        class="topBtn1"
                      >
                        申请发票
                      </div>
                      <div
                        v-if="scope.row.isAuth == 1 && scope.row.authPdf"
                        @click="downAuthBook(scope.row.authPdf)"
                        style="
                          color: #4bc185;
                          margin-left: 0.1rem;
                          line-height: 0.43rem;
                          cursor: pointer;
                        "
                      >
                        下载授权书
                      </div>
                      <div
                        v-else
                        @click="addAuth(scope.row)"
                        style="
                          color: #C01A26;
                          margin-left: 0.1rem;
                          line-height: 0.43rem;
                          cursor: pointer;
                        "
                      >
                        填写授权书
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <template #empty>
                  <div style="height: 550px" v-if="list.length == 0">
                    <div style="width: 90%; margin: 0 auto">
                      <img
                        style="width: 100%; margin: 0 auto"
                        src="../../assets/zt_404.png"
                      />
                    </div>
                  </div>
                </template>
              </el-table>
              <!-- <div style="height: 550px" v-if="list.length == 0">
                <div style="width: 60%; margin: 0 auto">
                  <img
                    style="width: 100%; margin: 0 auto"
                    src="../../assets/zt_404.png"
                  />
                </div>
              </div> -->
            </el-tab-pane>
          </el-tabs>
          <el-pagination
            v-if="list.length"
            v-model:current-page="page.pageNum"
            v-model:page-size="page.pageSize"
            @size-change="sizeChange"
            @current-change="currentChange"
            style="margin: 0.4rem 0"
            background
            layout="prev, pager, next"
            :total="page.total"
          />
        </div>
      </div>
    </div>
    <el-dialog title="填写授权信息" v-model="dialogFormVisible" align-center :close-on-click-modal="false">
      <purchasedMaterialAccredit
        v-model="form"
        @close="onClose"
        @submit="onSubmit"
      ></purchasedMaterialAccredit>
    </el-dialog>
  </div>
</template>

<script lang="ts" setup>
import leftTemplate1 from "@/components/leftTemplate1.vue";
import purchasedMaterialAccredit from "./purchasedMaterial-accredit.vue";
import { ref } from "vue";
import type { TabsPaneContext } from "element-plus";
import { ElTable, ElMessage } from "element-plus";
import axios from "axios";
import { Axios } from "../../assets/js/ls_com_axios.js";
import downFile from "../../assets/js/down.js";
import { useRouter } from "vue-router";
const router = useRouter();
const activeName = ref("first");

let pageDef = ref({
  pageNum: 1,
  pageSize: 5,
  total: 0,
});
const page = pageDef;
const single = ref(true);
const multiple = ref(true);
const form = ref<any>({});
const activeList = ref([
  {
    label: "全部素材",
    name: "first",
    satus: 1,
  },
  {
    label: "视频",
    name: "second",
    satus: 2,
  },
  {
    label: "音乐",
    name: "third",
    satus: 3,
  },
  {
    label: "图片",
    name: "four",
    satus: 4,
  },
]);
const top_type = ref("");
const selectRows = ref<Array<any>>([]);
const ids = ref<Array<number>>([]);
const handleClick = (tab: TabsPaneContext, event: Event) => {
  // 素材分类（IMAGE图片 MUSIC音乐 VIDEO视频）
  isTableLoading.value = false;
  let value =
    activeName.value == "first"
      ? ""
      : activeName.value == "second"
      ? "VIDEO"
      : activeName.value == "third"
      ? "MUSIC"
      : activeName.value == "four"
      ? "IMAGE"
      : "";
  top_type.value = value;
  init();
};

// 表格

const api = axios.create({
  baseURL: "https://api.biaoshisx.com",
  timeout: 1000 * 60 * 60 * 4,
});
//列表请求
var list = ref([]); // 创建一个空数组
const isTableLoading = ref(false);

const init = () => {
  let params = {
    materialType: top_type.value,
    pageNum: page.value.pageNum,
    pageSize: page.value.pageSize,
    orderByColumn: "payTime",
    isAsc: "desc",
  };
  isTableLoading.value = false;
  Axios("get", "/fodder/manage/pay-list", params, false, function (res: any) {
    list.value = res.data.rows;
    page.value.total = res.data.total;
  });
};
const handleSelectionChange = (selection: any) => {
  selectRows.value = selection;
  single.value = selection.length != 1;
  multiple.value = !selection.length;
  ids.value = selection.map((x: any) => x.id);
};
// 填写授权信息
const dialogFormVisible = ref(false);
const addAuth = (row: any) => {
  Axios("get", "/fodder/manage/auth/" + row.id, {}, false, function (res: any) {
    form.value = res.data.data;
    if (!form.value) {
      form.value = {};
      form.value.authType = row.authType;
    }
    form.value.payId = row.id;
  });
  dialogFormVisible.value = true;
};
const onClose = () => {
  dialogFormVisible.value = false;
};
const onSubmit = () => {
  dialogFormVisible.value = false;
  Axios("post", "/fodder/manage/auth", form.value, false, function (res: any) {
    ElMessage({
      showClose: true,
      message: "授权书申请已提交",
      type: "success",
    });
  });
};
/**
 * 分页
 * sizeChange
 * currentChange
 * prevClick
 * nextClick
 *
 */
const sizeChange = (val: number) => {
  console.log(val);
  init();
};
const currentChange = (val: number) => {
  console.log(val);
  page.value.pageNum = val;
  init();
};
const prevClick = (val: number) => {
  console.log(val);
  page.value.pageNum = val;
  init();
};
const nextClick = (val: number) => {
  page.value.pageNum = val;
  init();
};
const downAuthBook = (pdf: string) => {
  let link = document.createElement("a");
  fetch(pdf)
    .then((res) => res.blob())
    .then((blob) => {
      link.href = URL.createObjectURL(blob);
      link.download = "";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
};
const downMaterials = (
  row: any,
  files: Array<{ file: string; path: string }>
) => {
  row.zipLoading = true;
  api({
    method: "post",
    url: "/file/zip",
    data: { files },
  }).then((resp) => {
    row.zipLoading = false;
    if (row.percentage == 100) {
      row.percentage = 0;
    }
    downFile({
      pieceSize: 1,
      concurrent: 3,
      fileName: resp.data,
      downName: row.title + ".zip",
      process: ({ progress }) => {
        row.percentage = parseFloat(progress.toFixed(1));
      },
    });
  });
};
const downMulMaterial = () => {
  selectRows.value.forEach((element) => {
    downMaterials(element, [
      { file: element.title + "." + element.fileExt, path: element.sourcePath },
      { file: "封面.png", path: element.showImage },
    ]);
  });
};
const addInvoice = (row) => {
  const id = row.orderId;
  if (row.hasInvoice == 0) {
    router.push({
      path: "/invoiceDebit",
      query: {
        arry: id,
        type: "add",
      },
    });
  } else {
    ElMessage.warning("该订单已申请发票");
  }
};
init();
</script>

<style scoped>
@import url(/src/assets/css/left_right.css);
@import url(/src/assets/css/com.css);

.purchasedMaterial {
  display: flex;
  margin: 0 auto;
}

.newTrialMaterial_box {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0.2rem 0.17rem;
  box-sizing: border-box;
  vertical-align: middle;
  background-color: #f2f3f5;
}

.topBtn {
  font-size: 0.14rem;
  padding: 0.08rem 0.16rem;
  text-align: center;
  color: #333333;
  background: #ffffff;
  border-radius: 0.2rem;
  opacity: 1;
  border: 0.01rem solid #e5e6eb;
  margin-left: 0.2rem;
}

.topBtn1 {
  font-size: 0.14rem;
  padding: 0.08rem 0.16rem;
  text-align: center;
  color: #333333;
  background: #ffffff;
  border-radius: 0.2rem;
  opacity: 1;
  border: 0.01rem solid #e5e6eb;
}
.table_img {
  background-color: #3fa4ed;
  width: 1rem;
  height: 0.8rem;
  background: #d9d9d9;
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  opacity: 1;
  margin-right: 0.1rem;
}

.table_information {
  width: calc(100% - 1rem - 0.1rem);
  height: 0.8rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.satatusLab {
  padding: 0.02rem 0.06rem;
  box-sizing: border-box;
  border-radius: 0.02rem;
  margin-left: 0.12rem;
  display: inline-block;
}

/deep/.el-tabs__nav-wrap::after {
  display: none;
}

/deep/ .el-table th.el-table__cell.is-leaf {
  background: #e3e6ec !important;
}

/deep/th .cell .el-checkbox__input {
  display: none;
}

/deep/.el-checkbox.el-checkbox--large {
  height: 0.2rem !important;
}

/deep/.is-active {
  color: #C01A26;
}

/deep/.el-tabs__active-bar {
  display: none;
}

/deep/.el-tabs__nav {
  padding: 0 0.16rem;
}

/deep/.el-tabs__item:hover {
  color: #C01A26 !important;
}

/deep/.el-dialog.is-align-center {
  border-radius: 20px !important;
}

/* 分页 */

.el-pagination {
  justify-content: center;
}

/deep/.el-pager li {
  padding: 0.06rem;
  margin: 0 0.03rem;
}

/deep/.el-pager li.is-active {
  color: #fff;
  background: #C01A26;
}

/deep/.el-pager li:hover {
  color: #fff;
  background: #C01A26;
}

/deep/ .el-pagination.is-background .el-pager li.is-active {
  background: #C01A26;
}

/deep/.el-popper:focus {
  outline: none !important;
}
</style>
